<template>
  <div id="pageRoot">
    <p id="text01">
      ¿De quién se está hablando en cada enunciado?<br /><br />
      Escribe la respuesta en la línea.
    </p>

    <div class="tag" style="left: 350px; top: 260px; z-index: 3">
      <p class="textBase tagText">VENANCIO</p>
    </div>

    <div class="tag" style="right: -60px; top: 260px; z-index: 3">
      <p class="textBase tagText">DON FITO</p>
    </div>

    <p id="text04" class="label-inputs">Le gustaba volar bajito.</p>
    <p id="text05" class="label-inputs">Tenía muchísima paciencia.</p>
    <p id="text06" class="label-inputs">SE SUBÍA A LA TERRAZA Y LE GRITABA.</p>

    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText="VENANCIO"
      number="100"
      id="inputField01"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <!-- TEXT ----------------------------------------------------------------------------------------------------->

    <div id="dog" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage58Dog.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="donFito" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage58DonFito.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
    <span id="fixedBackground" class="pageElement"></span>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.tag {
  position: absolute;
  width: 310px;
  height: 70.55px;

  background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
  background-size: contain;
  background-repeat: no-repeat;
  transform: scale(0.6);
  transition: 0.3s;
}
#fixedBackground {
  position: absolute;
  width: 940px;
  height: 544px;
  left: 47px;
  top: 32px;
  background-image: url(/pages/img/sordo/svgPage58.svg);
}
#dog {
  position: absolute;
  width: 158.79px;
  height: 150.68px;
  left: 542px;
  top: 210px;
}
#donFito {
  position: absolute;
  width: 135.71px;
  height: 283.63px;
  left: 762px;
  top: 71px;
}
#inputField01 {
  width: 550px;
  margin-left: 42%;
  margin-top: 36.5%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
  opacity: 0.55;
}
#inputField02 {
  width: 515px;
  margin-left: 45.6%;
  margin-top: 45.2%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField03 {
  width: 410px;
  margin-left: 55.9%;
  margin-top: 54.1%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#text01 {
  /* ¿De quién se está hablando en cada enunciado? Escribe la respuesta en la línea. */

  position: absolute;
  left: 8.2%;
  right: 34.38%;
  top: 15.8%;
  bottom: 73.31%;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 26px;

  color: #000000;
}

#text02 {
  /* VENANCIO */

  position: absolute;
  width: 120px;
  height: 70px;
  left: 436px;
  top: 257px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;

  color: #ffffff;
}
#text03 {
  /* DON FITO */

  position: absolute;
  width: 112px;
  height: 70px;
  left: 890px;
  top: 260px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;

  color: #ffffff;
}
#textEjemplo {
  /*VENANCIO*/
  position: absolute;
  left: 58%;
  right: 44.14%;
  top: 49%;
  bottom: 64.97%;
  margin: 0px;
  z-index: 4;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
  line-height: 65px;
  color: #2bb673;
}
.label-inputs {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 37px;
  /* or 233% */
  text-transform: uppercase;

  color: #000000;
}

#text04 {
  /* Le gustaba volar bajito. Tenía muchísima paciencia. Se subía a la terraza y le gritaba. */

  position: absolute;
  width: 511px;
  height: 144px;
  left: 48px;
  top: 403px;
  margin: 0px;
  z-index: 3;
}

#text05 {
  position: absolute;
  width: 511px;
  height: 144px;
  left: 48px;
  top: 493px;
  margin: 0px;
  z-index: 3;
}

#text06 {
  position: absolute;
  width: 580px;
  height: 144px;
  left: 48px;
  top: 585px;
  margin: 0px;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p58/V17.mp4",
        "p58/V18.mp4",
        "p58/V19.mp4",
        "p58/V20.mp4",
        "p58/V21.mp4",
		"p59/V22.mp4",
      ],
    };
  },
};
</script>